"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._heading = undefined;

var _setImmediate2 = require("babel-runtime/core-js/set-immediate");

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _glamor = require("glamor");

var _auth = require("redux/modules/auth");

var authActions = _interopRequireWildcard(_auth);

var _actions = require("../../EpicMigration/actions");

var epicMigrationActions = _interopRequireWildcard(_actions);

var _reduxForm = require("redux-form");

var _loginFormValidation = require("utils/loginFormValidation");

var _loginFormValidation2 = _interopRequireDefault(_loginFormValidation);

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _jsonwebtoken = require("jsonwebtoken");

var _jsonwebtoken2 = _interopRequireDefault(_jsonwebtoken);

var _utils = require("./../../utils");

var _RedirectToExternalSite = require("./../../utils/RedirectToExternalSite");

var _Preloader = require("@quixeltools/quixel-ui-library/dist/components/common/website/Preloader");

var _Preloader2 = _interopRequireDefault(_Preloader);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _LoginWithEpic = require("./LoginWithEpic.scss");

var _LoginWithEpic2 = _interopRequireDefault(_LoginWithEpic);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _heading = exports._heading = (0, _glamor.css)({
  display: "block",
  position: "relative",
  paddingLeft: 0,
  paddingTop: 0
}, (0, _css.minWidth)(_css.breakpoints.mediumSmall)({
  display: "inline-block",
  paddingTop: "1rem",
  paddingLeft: "1.5rem"
}), (0, _css.minWidth)(_css.breakpoints.xlarge)({
  paddingTop: "1.2rem"
}));

var Login = (_dec = (0, _reduxForm.reduxForm)({
  form: "login",
  fields: ["email", "password"],
  validate: _loginFormValidation2.default
}, function (state) {
  return {
    auth: state.auth,
    avatarfileName: state.auth.avatarfileName
  };
}, (0, _extends3.default)({}, authActions, epicMigrationActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Login, _Component);

  function Login(props) {
    (0, _classCallCheck3.default)(this, Login);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).call(this, props));

    _this.initializationEpicLogin = _this.initializationEpicLogin.bind(_this);

    _this.state = {
      showSignInPopup: true,
      transitioned: false
    };
    return _this;
  }

  (0, _createClass3.default)(Login, [{
    key: "initializationEpicLogin",
    value: function initializationEpicLogin() {
      var _props = this.props,
          rememberWeAreRedirectingToEpicLogin = _props.rememberWeAreRedirectingToEpicLogin,
          isRegisterLinkVariant = _props.isRegisterLinkVariant;
      var location = this.context.router.location;


      rememberWeAreRedirectingToEpicLogin(location, isRegisterLinkVariant ? "register" : "login");
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializationEpicLogin();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.style.position = "inherit";
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _props2 = this.props,
          location = _props2.location,
          navigateTo = _props2.navigateTo;


      if (nextProps.auth.loggedIn && !this.state.transitioned) {
        this.setState({ transitioned: true });

        var returnTo = location.query.returnTo && location.query.returnTo.indexOf("signup") === -1 ? location.query.returnTo : "/";
        if (!navigateTo && location.query.returnTo) (0, _setImmediate3.default)(function () {
          _this2.context.router.push(returnTo);
        });
      }
      if (nextProps.auth.zendeskTokenSSO && nextProps.auth.zendeskTokenSSO !== this.props.auth.zendeskTokenSSO) {
        var tokenObject = _jsonwebtoken2.default.decode(nextProps.auth.zendeskTokenSSO);
        this.setState({
          showSignInPopup: false
        });
        if (_underscore2.default.isEmpty(tokenObject.name)) {
          this.context.dialogs.custom(_react2.default.createElement(_components.ZendeskScreenNamePopupContainer, null));
        } else {
          console.log("redirect");
          if (location.query.return_to) {
            var return_to = location.query.return_to;
            var hostName = "https://" + (0, _utils.extractHostname)(return_to);
            if (!/\d/.test(hostName)) {
              hostName = "https://quixel.zendesk.com";
            }
            var zendeskJwtLink = hostName + "/access/jwt?jwt=" + nextProps.auth.zendeskTokenSSO + "&return_to=" + encodeURIComponent(return_to);
            (0, _RedirectToExternalSite.checkRedirectRequired)(zendeskJwtLink);
          }
        }
      }
      if (nextProps.auth.avatarSrc && this.props.auth.avatarSrc !== nextProps.auth.avatarSrc) {
        this.props.uploadAvatarZendesk(nextProps.auth.avatarSrc);
        this.setState({
          showSignInPopup: false
        });
      }
      if (this.props.auth.screenName !== nextProps.auth.screenName && nextProps.auth.screenName && this.props.auth.zendeskTokenSSO) {
        this.setState({
          showSignInPopup: false
        });
        var data = {
          token: this.props.auth.zendeskTokenSSO,
          screenName: nextProps.auth.screenName
        };
        if (this.props.auth.avatarfileName) data.avatarUrl = this.props.auth.avatarfileName;
        this.props.updateScreenNameSSOZendesk(data);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "- Sign in or register, and start creating today",
          documentDescription: "Log in with your Epic Games ID for free, unlimited access to the Megascans 3D asset library. Or subscribe to one of our affordable licenses."
        },
        this.state.showSignInPopup ? _react2.default.createElement(
          "div",
          { className: _LoginWithEpic2.default.overlay },
          _react2.default.createElement(
            "div",
            { className: _LoginWithEpic2.default.wrap },
            _react2.default.createElement(
              "div",
              { className: _LoginWithEpic2.default.preloader },
              _react2.default.createElement(_Preloader2.default, null)
            ),
            _react2.default.createElement(
              "span",
              { className: _LoginWithEpic2.default.label },
              "Signing in..."
            )
          )
        ) : _react2.default.createElement("div", null)
      );
    }
  }]);
  return Login;
}(_react.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class);

var LoginWithEpic = function (_React$Component) {
  (0, _inherits3.default)(LoginWithEpic, _React$Component);

  function LoginWithEpic() {
    (0, _classCallCheck3.default)(this, LoginWithEpic);
    return (0, _possibleConstructorReturn3.default)(this, (LoginWithEpic.__proto__ || (0, _getPrototypeOf2.default)(LoginWithEpic)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginWithEpic, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(Login, this.props);
    }
  }]);
  return LoginWithEpic;
}(_react2.default.Component);

exports.default = LoginWithEpic;


//////////////////
// WEBPACK FOOTER
// ./src/pages/LoginWithEpic/LoginWithEpic.jsx
// module id = 2897
// module chunks = 0